<div class="advertisement_extra_details">
    <div
        id="more_details"
        [class.show]="IsExtraDetailsCollapsed"
        class="more_details wrap_text_details border_r_2th position-relative text-start"
    >
        <div class="text-center">
            <h5 (click)="ToggleExtraDetailsCollapse()" class="sub_title bold pointer gap-2 d-inline-flex d-flex align-items-center padding_y_2">
                <span>عرض معلومات أخري عن العقار</span>
                <span class="effect font_20 font_600 pointer border border-2 border_r_full icon_32 d-flex align-items-center justify-content-center">
                    <i 
                        [ngClass]="[IsExtraDetailsCollapsed ? 'fa-arrow-up' : 'fa-arrow-down']"
                        class="fa-solid fa-sm border_r_full d-flex align-items-center justify-content-center">
                    </i>
                </span>              
            </h5>
        </div>

        <h4 class="sub_title bold font_size_15 lh_none color_black text_under">وصف العقار</h4>
        <p 
            class="sub_title description"
            [innerHTML]="AdvertisementData?.description"
        >
        </p>

        <ng-container *ngIf="AdvertisementData?.bestFeature">
            <h4 class="sub_title bold font_size_15 lh_none color_black text_under">افضل المميزات</h4>
            <p 
                class="sub_title best_feature elp"
                [innerHTML]="AdvertisementData?.bestFeature"
            >
            </p>
        </ng-container>

        <!-- start rega-ad-data -->
        <ng-container *ngIf="RegaAdvertisementData != null">
        <div class="wrap_rega_ad_data position-relative overflow-hidden">
                <app-rega-ad-data [data]="RegaAdvertisementData" class="d-block margin_top_8" />
            </div>
        </ng-container>
        <!-- end rega-da-data -->

    </div>
</div>